import React from "react"
import Container from "@ecom/ui/components/Container"
import clsx from "clsx"
import Button from "@material-ui/core/Button"
import * as styles from "./refinBlock.module.scss"
import { RefinBlockItems } from "./items"
import scrollToPersonalForm from "../../helpers/scrollToPersonalForm"
import { DLClickEventExtended } from "../../helpers/WatcherDL/DLEvents"

interface RefinBlockProps {
  title?: React.ReactNode
  description?: React.ReactNode
  orderNum?: string
  buttonText?: string
}

const defaultTitle = <>Преимущества рефинансирования с&nbsp;Халвой</>
const defaultDescription = (
  <>Переводите долги на Халву — одна карта, комфортный платёж, быстрое&nbsp;решение</>
)

export const RefinBlock = ({
  orderNum,
  title = defaultTitle,
  description = defaultDescription,
  buttonText = "Подать заявку",
}: RefinBlockProps) => {
  const handleClick = () => {
    DLClickEventExtended({
      name: buttonText,
      eventAction: "CTA в калькуляторе",
      placement: "calculator",
    })

    scrollToPersonalForm()
  }
  return (
    <section className={styles.section} data-exclude={orderNum} id="refinBlock">
      <Container>
        <div className={styles.titleBlock}>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.description}>{description}</p>
        </div>
        <div className={styles.grid}>
          {RefinBlockItems.map(({ titleItemBlock, descriptionItemBlock, imgItemBlock }, index) => {
            const imgClass = styles[`img_${index}`]

            return (
              <div className={styles.itemBlock} key={index}>
                {titleItemBlock}
                {descriptionItemBlock}
                <div className={clsx(styles.image, imgClass)}>{imgItemBlock}</div>
              </div>
            )
          })}
        </div>
        <Button className={styles.btn} onClick={handleClick}>
          {buttonText}
        </Button>
      </Container>
    </section>
  )
}
